import copy from './copy.svg';

export default { copy };
